import React, { Component } from 'react';

/****************************************
    Component for Contact Office Block of a page
    @author  IMH003
    @date    2020.05.27
    @version 0.1    
 ******************************************/
class ContactBlock extends Component {
    
    componentWillMount() {
    }

    componentDidMount() {    
       
    }
  
    componentDidUpdate() {
       
    }

    componentWillUnmount() {
    }

    componentWillReceiveProps(newProps) {
    }

    render() {

        return (
            
            <div className="contact-item text-left">                
                <h4 className="title">{this.props.title}</h4>
                <p className="meta"><span className="icon icon-phone"></span>{this.props.phone}</p>
                <p className="meta"><span className="icon icon-fax"></span>{this.props.fax}</p>
                <p className="meta"><span className="icon icon-envelope"></span>{this.props.email}</p>
            </div>
        );
    }
}

export default ContactBlock;
